import { useDialog } from '@src/components/dialog'
import { ApiErrorResponse, getApiErrorResponse, isApiError } from '@src/domain/api'
import { AxiosError, isAxiosError } from '@src/lib/axios'
// import { useNavigate } from 'react-router-dom'

export const useGlobalErrorHandler = () => {
  const { dialog } = useDialog()
  // const navigation = useNavigate()
  async function globalErrorHandler(error: unknown) {
    if (isApiError(error)) {
      const apiError = error as AxiosError<ApiErrorResponse>
      const apiErrorResponse = getApiErrorResponse(apiError)

      await dialog.alert({
        title: '錯誤',
        message: apiErrorResponse.message
      })
      return
    }

    if (isAxiosError(error)) {
      const axiosErrorCode = error.code || '';

      if (['ECONNABORTED', 'ERR_NETWORK'].includes(axiosErrorCode)) {
        await dialog.alert({
          title: '錯誤',
          message: '網路連線失敗，請檢查網路連線是否正常。'
        })

        return
      }

      if (error.status === 401) {
        await dialog.alert({
          title: '錯誤',
          message: '登入憑證已過期，請重新登入。'
        })

        // navigation('/login')
        return
      }
    }

    // 處理其他未知錯誤
    const isErrorObject = error instanceof Error
    const errorMessage = JSON.stringify(isErrorObject ? error.stack : error, null, 2)
    await dialog.alert({
      title: '發生非預期錯誤',
      message: errorMessage
    })
  }
  return {
    globalErrorHandler
  }
}
